import { getCurrentModule } from 'owa-app-module-store';
import { resetFocus } from 'owa-mail-focus-manager';
import { isAnySxSDisplayedInMainWindow } from 'owa-sxs-store';
import { lazyUndo } from '../lazyFunctions';

export default function onUndoButtonClicked(): void {
    if (getCurrentModule() !== 'Mail') {
        return;
    }

    if (!isAnySxSDisplayedInMainWindow()) {
        void lazyUndo.importAndExecute('Keyboard');
    }

    resetFocus('undoCommand');
}
